import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ShieldX, ArrowLeft, Home } from 'lucide-react';

export const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-[70vh] flex items-center justify-center p-6" data-testid="access-denied-page">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-red-100 flex items-center justify-center">
          <ShieldX className="w-10 h-10 text-red-600" />
        </div>
        
        <h1 className="font-sweet-sans text-2xl font-bold text-earth-brown mb-3">
          Toegang Geweigerd
        </h1>
        
        <p className="font-sweet-sans text-gray-600 mb-6">
          U heeft geen toestemming om deze pagina te bekijken. 
          Deze functie is alleen beschikbaar voor beheerders met de juiste rechten.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="border-gray-300"
            data-testid="go-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Ga Terug
          </Button>
          
          <Button
            onClick={() => navigate('/admin/dashboard')}
            className="bg-earth-brown hover:bg-earth-brown/90 text-white"
            data-testid="go-dashboard-btn"
          >
            <Home className="w-4 h-4 mr-2" />
            Naar Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};
